export default "__VITE_ASSET__0183d89b__"